import { useMutation } from "@shared/lib/hooks";
import { ToastService } from "@shared/lib/services";
import { useCallback } from "react";
import { AI_WORKSPACE_QUERY_KEYS } from "../constants";
import { AiWorkspaceService } from "../services/aiWorkspace.service";
import { IUpdateScriptGenerationMasterPromptPayload } from "../types";
import { readApiError } from "./readApiError";

const QUERY_OPTIONS = {
  queryKey: [AI_WORKSPACE_QUERY_KEYS.GET],
  skipInvalidation: false,
};

export function useUpdateScriptGenerationMasterPrompt(config?: {
  onSuccess?: () => void;
}) {
  const updateScriptGenerationMasterPrompt = useCallback(
    (payload: IUpdateScriptGenerationMasterPromptPayload) =>
      AiWorkspaceService.updateScriptGenerationMasterPrompt(payload).catch(
        async (err) => {
          ToastService.error(
            await readApiError(err, "Failed to update master prompt")
          );
          throw err;
        }
      ),
    []
  );

  const { mutate: update, isLoading: isUpdating } =
    useMutation<IUpdateScriptGenerationMasterPromptPayload>({
      mutationFn: updateScriptGenerationMasterPrompt,
      options: QUERY_OPTIONS,
      onSuccess: config?.onSuccess,
    });

  return { update, isUpdating };
}
